var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSvg4 = function SvgSvg4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.168,
    height: 213.156
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "svg4_svg__a",
    width: 157.959,
    height: 208.79,
    x: 0,
    y: 4.366,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#33333350",
    strokeMiterlimit: 10,
    d: "M151.575 130.91h-18.382V76.78a10.84 10.84 0 0 0-10.845-10.841h-4.3a10.84 10.84 0 0 0-10.841 10.841v54.131h-51.85a6.19 6.19 0 0 1-5.472-9.08l54.877-103.865a10.84 10.84 0 0 0-4.956-14.867l-3.24-1.53a10.84 10.84 0 0 0-14.189 4.692L15.448 131.466a14.7 14.7 0 0 0-1.736 6.93 14.7 14.7 0 0 0 14.7 14.7h78.8v34.229a12.994 12.994 0 0 0 12.987 12.994 12.994 12.994 0 0 0 12.994-12.994v-34.23h18.382a11.093 11.093 0 0 0 11.093-11.093 11.093 11.093 0 0 0-11.092-11.093Z",
    "data-name": "Caminho 4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg4_svg__a)",
    transform: "translate(0 -.002)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M142.364 137.244h-18.382V83.113a10.84 10.84 0 0 0-10.842-10.84h-4.307a10.84 10.84 0 0 0-10.841 10.841v54.131H46.14a6.19 6.19 0 0 1-5.472-9.08L95.549 24.3a10.84 10.84 0 0 0-4.956-14.867l-3.24-1.53a10.84 10.84 0 0 0-14.189 4.692L6.234 137.8a14.7 14.7 0 0 0-1.736 6.93 14.7 14.7 0 0 0 14.7 14.7h78.8v34.229a12.994 12.994 0 0 0 12.994 12.994 12.994 12.994 0 0 0 12.994-12.994v-34.23h18.382a11.093 11.093 0 0 0 11.093-11.093 11.093 11.093 0 0 0-11.093-11.093Z",
    "data-name": "Caminho 2"
  })))));
};
export default SvgSvg4;